<h2 mat-dialog-title>Audit Trail Details</h2>
<div mat-dialog-content *ngIf="data != null">
    <p class="details">Date Time: {{data.details.datetime}}</p>
    <p class="details">Table Name: {{data.details.tablename}}</p>
    <table mat-table [dataSource]="dataSource" class="demo-table">
        <ng-container matColumnDef="fieldname">
          <th mat-header-cell *matHeaderCellDef>Field name</th>
          <td mat-cell *matCellDef="let element">{{element.fieldname}}</td>
        </ng-container>
        <ng-container matColumnDef="previousvalue" *ngIf="!(action == 'Insert' || action == 'Update' || action == 'Delete')">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let element">{{element.previousvalue}}</td>
          </ng-container>
          <ng-container matColumnDef="newvalue" *ngIf="!(action == 'Insert' || action == 'Update' || action == 'Delete')">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">{{element.newvalue}}</td>
          </ng-container>
        <ng-container matColumnDef="previousvalue" *ngIf="action == 'Insert' || action == 'Update' || action == 'Delete'">
          <th mat-header-cell *matHeaderCellDef >Previous Value</th>
          <td mat-cell *matCellDef="let element">{{element.previousvalue}}</td>
        </ng-container>
        <ng-container matColumnDef="newvalue" *ngIf="action == 'Insert' || action == 'Update' || action == 'Delete'">
          <th mat-header-cell *matHeaderCellDef>New Value</th>
          <td mat-cell *matCellDef="let element">{{element.newvalue}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>


<!-- Copyright 2023 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->